import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { AdyenConfigurationCard } from './components/adyen-configuration-card'
import { AdyenDescriptorCard } from './components/adyen-descriptor-card'
import { AdyenFeaturesCard } from './components/adyen-features-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface AdyenProcessorDetailsPageProps {
    processor: ProcessorDetails
}

export const AdyenProcessorDetailsPage = ({ processor }: AdyenProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader
                type="adyen"
                processor={processor}
            />
            <ProcessorOverviewCard processor={processor} testModeWarningKey="adyenTestModeWarning" />
            <ProcessorMetricsCard processor={processor} />
            <AdyenConfigurationCard processor={processor} />
            <AdyenDescriptorCard processor={processor} />
            <ProcessorPaymentMethodsCard processor={processor} />
            <AdyenFeaturesCard />
        </>
    )
}
